import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Redirect, Link } from "react-router-dom";
import "./auth.scss";
import { Helmet } from "react-helmet";
import serviceProvider from '../../services/axios'

export class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      msg: "",
      isLoading: false,
      redirect: false,
      errMsgEmail: "",
      errMsgPwd: "",
      errMsg: "",
      passwordShown: false,
    };
  }
  
  onChangehandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let data = {};
    data[name] = value;
    this.setState(data);
  };

  onSignInHandler = () => {
    this.setState({ isLoading: true });
    serviceProvider
      .post(
        "/user?type=signin",
        JSON.stringify({
          email: this.state.email,
          password: this.state.password,
        })
      )
      .then((response) => {
        this.setState({ isLoading: false });
        if (response.data.status == 200) {
					localStorage.setItem("isLoggedIn", true);
					localStorage.setItem("userData", JSON.stringify(response.data.data));
					localStorage.setItem("group_id", JSON.stringify(response.data.data.group_id));
          			localStorage.setItem("access_token", JSON.stringify(response.data.data.access_token));
          			localStorage.setItem("refresh_token", JSON.stringify(response.data.data.refresh_token));

					if(parseInt(response.data.data.group_id) == 2){
						window.location = "/educate-prepare-home";
					}
					else if(parseInt(response.data.data.group_id) == 11){
						window.location = "/educate-prepare-home";
					}
					else{
						window.location = "/educate-prepare-home";
					}
        }
        if (
          response.data.status == "failed" &&
          response.data.success == "undefined"
        ) {
          this.setState({
            errMsgEmail: response.data.validation_error.email,
            errMsgPwd: response.data.validation_error.password,
          });
          setTimeout(() => {
            this.setState({ errMsgEmail: "", errMsgPwd: "" });
          }, 5000);
        } else if (
          response.data.status === "failed" &&
          response.data.success === false
        ) {
          this.setState({
            errMsg: response.data.message,
          });
          setTimeout(() => {
            this.setState({ errMsg: "" });
          }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  onKeyPress = (e) => {
    if (e.which === 13) {
      this.onSignInHandler();
    }
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to="/educate-prepare-home" />;
    }
    const login = localStorage.getItem("isLoggedIn");
    if (login) {
      return <Redirect to="/educate-prepare-home" />;
    }
    const isLoading = this.state.isLoading;

    return (
      <React.Fragment>
        <Helmet>
          <title>Sign In | SmarterChains</title>
          <meta name="description" content="Sign In" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        <div className="auth__form--wrapp">
          {/* <Grid container> */}
          {/* left section image */}
          <Grid item xs={12} sm={4} md={4} className="auth__form--left">
            <div className="auth__form--logo">
              <img src={require("../../assets/img/auth/sc-logo.svg").default} />
            </div>
          </Grid>
          {/* right section  */}
          <Grid item xs={12} sm={12} md={8} className="auth__form--right">
            <div className="wrapper sign-in">
              <div className="col-6 Signup-form">
                <h1>Welcome back</h1>
                <p>
                  Log in with the data you entered during your registration.
                </p>
                <form className="signup-box">
                  <div className="form-group">
                    <div className="col-12">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={this.state.email}
                        onChange={this.onChangehandler}
                        onKeyPress={this.onKeyPress}
                      />
                      <label className="error">{this.state.errMsgEmail}</label>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-12">
                      <label>Password</label>
                      <input
                        className="password-p"
                        type={!this.state.passwordShown ? "password" : "text"}
                        name="password"
                        placeholder="********"
                        value={this.state.password}
                        onChange={this.onChangehandler}
                        onKeyPress={this.onKeyPress}
                      />
                      <span
                        onClick={() =>
                          this.setState({
                            passwordShown: !this.state.passwordShown,
                          })
                        }
                        className={`form-control ${
                          this.state.passwordShown
                            ? "fa fa-fw field-icon toggle-password fa-eye"
                            : "fa fa-fw field-icon toggle-password fa-eye-slash"
                        }`}
                      />
                      <label className="error">{this.state.errMsgPwd}</label>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="signup"
                    color="success"
                    onClick={this.onSignInHandler}
                  >
                    Login
                  </button>
                  <span>
                    Don't have an account?
                    <Link className="log_in_b" to="/sign-up">
                      Sign up
                    </Link>
                    <br />
                    <Link className="log_in_b" to="/forgot-password">
                      Forgot password?
                    </Link>
                  </span>
                  <p className="terms-privacy-text">
                    By clicking on Login, you agree to SmarterChains’
                    <a
                      href="//www.smarterchains.com/terms-of-service"
                      className="services"
                      target="_blank"
                    >
                      Terms of service,
                    </a>
                    <a
                      href="//www.smarterchains.com/website-terms-of-use"
                      className="terms"
                      target="_blank"
                    >
                      Terms of use
                    </a>
                    and
                    <a
                      href="//www.smarterchains.com/privacy-policy"
                      className="privacy"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                    .
                  </p>
                </form>
              </div>
            </div>
          </Grid>
          {/* </Grid> */}
        </div>
      </React.Fragment>
    );
  }
}
